/*
  YG · Omaggi Kaching nel carrello.

  Due buchi, una sola causa. L'omaggio di Kaching e' agganciato all'**istanza**
  dell'offerta, non alla quantita' della riga: ogni bundle porta un suo codice
  di raggruppamento, e l'app aggiunge le righe omaggio solo quando quell'istanza
  nasce passando da lei.

  1. Upsell del cassetto ("Spesso acquistati insieme"): il prodotto entra senza
     property e senza offerta registrata in quel contesto, quindi niente omaggio.
  2. Tasto + su una riga che gia' porta un bundle: alza la quantita' ma non crea
     una seconda istanza. Misurato: 2 creme a 84,00 € con un solo Good Night.
     Due aggiunte separate dalla scheda invece danno due righe e due omaggi, che
     e' il comportamento corretto.

  Come si rimedia senza inventare niente. Non si scrive mai a mano
  properties[__kaching_bundles]: si monta il widget vero dell'app fuori
  schermo, si sceglie la fascia a quantita' 1 che regala qualcosa, e si lascia
  che sia l'app a scrivere la property e a fare l'aggiunta.

  Due cose scoperte provando, che non sono ovvie:
  - gli omaggi li aggiunge il percorso **submit del form**. Una fetch a
    /cart/add.js con la property corretta copiata di peso NON li produce:
    verificato, entra il prodotto e basta.
  - il form va dotato di una rete `submit -> preventDefault`, altrimenti se
    l'app non intercetta parte l'invio nativo e la pagina naviga.

  Qui non si intercettano le richieste del carrello: si **osserva** e si
  corregge dopo. Se qualcosa va storto il carrello resta quello di prima, che
  e' il comportamento di oggi: si sbaglia dalla parte che non rompe niente.
*/
(function () {
  'use strict';

  var MS_MONTAGGIO = 8000;
  var MS_SELEZIONE = 800;
  var MS_INVIO = 7000;   // tetto, non attesa: si aspetta il carrello vero
  var MS_RITARDO = 800;  // quanto si lascia passare prima di ricontrollare
  var MAX_CORREZIONI = 6; // paracadute: oltre, qualcosa non sta convergendo

  var offerte = new Map();  // productId -> barId | null
  var occupato = false;
  var giri = 0;

  function log() {
    if (window.YG_BUNDLE_CART_DEBUG) console.log.apply(console, ['[yg-bundle-cart]'].concat([].slice.call(arguments)));
  }

  function attendi(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function appPronta() {
    return typeof window.__kachingBundlesInitializeInternal === 'function' &&
           window.kachingBundlesApi && typeof window.kachingBundlesApi.fetchDeals === 'function';
  }

  /* L'app si carica come modulo, quindi a DOMContentLoaded non c'e' ancora:
     controllarla subito faceva uscire lo script in silenzio. Si aspetta, e
     si rinuncia solo dopo un tempo generoso. */
  async function attendiApp(msMax) {
    var scade = Date.now() + (msMax || 15000);
    while (Date.now() < scade) {
      if (appPronta()) return true;
      await attendi(250);
    }
    return false;
  }

  function carrello() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function proprieta(riga) {
    var p = riga.properties && riga.properties.__kaching_bundles;
    if (!p) return null;
    try { return JSON.parse(p); } catch (e) { return null; }
  }

  /* Costruisce fuori schermo un form con dentro il widget dell'app, sceglie la
     fascia giusta e invia. Ritorna true se l'invio e' partito. */
  async function creaIstanza(productId, variantId) {
    var box = document.createElement('div');
    box.style.cssText = 'position:absolute!important;left:-9999px;top:0;width:400px;height:1px;overflow:hidden';

    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.innerHTML = '<input type="hidden" name="id" value="' + variantId + '">' +
                     '<button type="submit" name="add">add</button>';
    var widget = document.createElement('kaching-bundle');
    widget.setAttribute('product-id', String(productId));
    form.insertBefore(widget, form.firstChild);
    box.appendChild(form);
    document.body.appendChild(box);

    /* Senza questa, se l'app non intercetta parte il post nativo e la pagina
       naviga via portandosi dietro il cliente. */
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    var pulisci = function () { try { box.remove(); } catch (e) {} };

    try {
      window.__kachingBundlesInitializeInternal();
    } catch (e) {
      log('inizializzazione fallita', e && e.message); pulisci(); return false;
    }

    var prop = function () { return form.querySelector('input[name*="__kaching_bundles"]'); };
    var scade = Date.now() + MS_MONTAGGIO;
    while (Date.now() < scade && !prop()) await attendi(150);
    if (!prop()) { log('widget non montato per', productId); pulisci(); return false; }

    var barId = await fasciaConOmaggio(productId, JSON.parse(prop().value).deal);
    if (!barId) { pulisci(); return false; }

    var etichetta = widget.querySelector('label[for^="' + barId + '"] [role="button"]') ||
                    widget.querySelector('label[for^="' + barId + '"]');
    if (etichetta) etichetta.click();
    await attendi(MS_SELEZIONE);

    var attuale = prop();
    var scelta = null;
    try { scelta = JSON.parse(attuale.value); } catch (e) {}
    if (!scelta || scelta.bid !== barId) {
      log('fascia non selezionata', scelta && scelta.bid, 'attesa', barId); pulisci(); return false;
    }

    /* Invece di un'attesa cieca si guarda il carrello vero: appena cresce,
       l'istanza c'e'. Taglia diversi secondi, e il cliente la correzione la
       vede accadere. */
    var prima = 0;
    try { prima = (await carrello()).item_count; } catch (e) {}
    form.querySelector('button[type="submit"]').click();

    var limite = Date.now() + MS_INVIO;
    while (Date.now() < limite) {
      await attendi(250);
      try { if ((await carrello()).item_count > prima) break; } catch (e) {}
    }
    pulisci();
    log('istanza creata', scelta.deal, scelta.bid, scelta.id);
    return true;
  }

  /* La fascia a quantita' 1 che regala qualcosa, cercata per id e mai per il
     testo del bottone, che cambia a ogni offerta nuova. */
  async function fasciaConOmaggio(productId, nanoId) {
    if (offerte.has(productId)) return offerte.get(productId);
    var barId = null;
    try {
      var deals = await window.kachingBundlesApi.fetchDeals();
      var d = deals.filter(function (x) { return x.nanoId === nanoId; })[0];
      var bar = d && (d.dealBars || []).filter(function (b) {
        return b && b.quantity === 1 && (b.freeGifts || []).length > 0;
      })[0];
      barId = bar ? bar.id : null;
    } catch (e) { log('lettura offerte fallita', e && e.message); }
    offerte.set(productId, barId);
    return barId;
  }

  /* Il prodotto ha un'offerta con omaggio a 1 pezzo? Si scopre montando il
     widget: l'app sa a quali prodotti si applica, noi no. Il risultato resta
     in cache, cosi' si paga una volta sola per prodotto. */
  async function haOmaggio(productId) {
    if (offerte.has(productId)) return !!offerte.get(productId);

    var box = document.createElement('div');
    box.style.cssText = 'position:absolute!important;left:-9999px;top:0;width:400px;height:1px;overflow:hidden';
    var widget = document.createElement('kaching-bundle');
    widget.setAttribute('product-id', String(productId));
    box.appendChild(widget);
    document.body.appendChild(box);

    try { window.__kachingBundlesInitializeInternal(); } catch (e) {}
    var scade = Date.now() + MS_MONTAGGIO;
    while (Date.now() < scade && !widget.querySelector('input[type="radio"]')) await attendi(150);

    var nano = null;
    var radio = widget.querySelector('input[type="radio"]');
    if (radio) {
      var m = (radio.name || '').match(/kaching-bundles-deal-(.+)$/);
      var cfg = widget.querySelector('script.kaching-bundles-deal-block-settings');
      if (cfg) { try { nano = JSON.parse(cfg.textContent).nanoId; } catch (e) {} }
      if (!nano) {
        /* Senza il blocco impostazioni si risale dall'elenco delle offerte:
           la fascia selezionata porta il proprio id nel valore del radio. */
        try {
          var deals = await window.kachingBundlesApi.fetchDeals();
          var valori = [].slice.call(widget.querySelectorAll('input[type="radio"]')).map(function (r) { return r.value; });
          var d = deals.filter(function (x) {
            return (x.dealBars || []).some(function (b) { return valori.indexOf(b.id) > -1; });
          })[0];
          nano = d ? d.nanoId : null;
        } catch (e) {}
      }
    }
    try { box.remove(); } catch (e) {}

    if (!nano) { offerte.set(productId, null); return false; }
    var barId = await fasciaConOmaggio(productId, nano);
    return !!barId;
  }

  /* Cerca una sola anomalia per giro e la corregge: cosi' ogni passaggio
     rilegge il carrello vero invece di lavorare su una fotografia vecchia. */
  async function correggi() {
    if (occupato) return;
    occupato = true;
    giri = 0;

    if (!(await attendiApp())) {
      log('Kaching non disponibile, niente da correggere');
      occupato = false;
      return;
    }

    try {
      while (giri < MAX_CORREZIONI) {
        giri += 1;
        var c = await carrello();
        var fatto = false;

        for (var i = 0; i < c.items.length; i++) {
          var riga = c.items[i];
          var p = proprieta(riga);

          // A) riga di bundle con quantita' alzata: una istanza per pezzo
          if (p && p.main && riga.quantity > 1) {
            var extra = riga.quantity - 1;
            log('riga bundle a quantita', riga.quantity, '-> riporto a 1 e creo', extra, 'istanze');
            await fetch('/cart/change.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: riga.key, quantity: 1 })
            });
            for (var n = 0; n < extra; n++) await creaIstanza(riga.product_id, riga.id);
            fatto = true;
            break;
          }

          // B) riga senza property di un prodotto che regala a 1 pezzo
          if (!p && riga.final_line_price > 0) {
            if (await haOmaggio(riga.product_id)) {
              log('riga senza omaggio', riga.product_title, '-> rifatta come bundle');
              var quante = riga.quantity;
              await fetch('/cart/change.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: riga.key, quantity: 0 })
              });
              for (var k = 0; k < quante; k++) await creaIstanza(riga.product_id, riga.id);
              fatto = true;
              break;
            }
          }
        }

        if (!fatto) break;
      }
    } catch (e) {
      log('correzione interrotta', e && e.message);
    } finally {
      occupato = false;
      aggiornaInterfaccia();
    }
  }

  /* Il cassetto e il contatore vanno rinfrescati: la correzione passa dalle
     API del carrello e nessuna app se ne accorge da sola. */
  function aggiornaInterfaccia() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      if (window.upCart && typeof window.upCart.refresh === 'function') window.upCart.refresh();
    } catch (e) {}
  }

  /* Si osserva soltanto: le richieste non vengono toccate, si guarda quando
     passano per sapere che e' il momento di ricontrollare. */
  function osserva() {
    var daControllare = function () {
      clearTimeout(osserva._t);
      osserva._t = setTimeout(correggi, MS_RITARDO);
    };

    var fetchOriginale = window.fetch;
    window.fetch = function (risorsa) {
      var url = '';
      try { url = typeof risorsa === 'string' ? risorsa : (risorsa && risorsa.url) || ''; } catch (e) {}
      var p = fetchOriginale.apply(this, arguments);
      if (/\/cart\/(add|change|update)/.test(url)) { try { p.then(daControllare, function () {}); } catch (e) {} }
      return p;
    };

    var apriOriginale = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (metodo, url) {
      if (/\/cart\/(add|change|update)/.test(String(url))) {
        this.addEventListener('load', daControllare);
      }
      return apriOriginale.apply(this, arguments);
    };
  }

  function avvia() {
    /* Gli osservatori si installano sempre: non toccano le richieste, e se
       l'app non arrivasse mai la correzione semplicemente non parte. */
    osserva();
    log('in ascolto');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
